import * as React from 'react'

export type Props = {
    quoteType: string
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    hide?: boolean
}

const PolicyIdField: React.SFC<Props> = ({
    quoteType,
    onChange,
    hide = false,
}) => {

    if (quoteType === 'hiscox' || hide) return null

    const isHcc = quoteType === 'hcc'
    const label = isHcc ? 'Policy Id' : 'Bespoke Policy:'
    const placeholder = isHcc ? 'Policy ID' : 'Bespoke Policy ID'

    return (
        <div className="quotePreview__row">
            <div className="text">{label}</div>
            <div className="quotePreview__row__inception_date">
                <input
                    type="text"
                    name="bespokePolicyId"
                    placeholder={placeholder}
                    required={isHcc}
                    onChange={onChange}
                />
            </div>
        </div>
    )
}

export default PolicyIdField



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/PolicyId/PolicyId.tsx